import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DigitalSignatureRectangleInitComponent} from './digital-signature-rectangle-init/digital-signature-rectangle-init.component';
import {DigitalSignatureRectangleSignedDocumentComponent} from './digital-signature-rectangle-signed-document/digital-signature-rectangle-signed-document.component';
import {DigitalSignatureRectangleCreateComponent} from './digital-signature-rectangle-create/digital-signature-rectangle-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {path: 'signature-rectangle-create/:documentUUID/:fileName', component: DigitalSignatureRectangleCreateComponent},
      {path: 'signature-rectangle-init', component: DigitalSignatureRectangleInitComponent},
      {path: 'get-signed-document/:documentUUID', component: DigitalSignatureRectangleSignedDocumentComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignatureRoutingModule {

}
